import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPath = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 10.72c-.507 0-.96.2-1.307.513L5.94 8.467C5.973 8.313 6 8.16 6 8c0-.16-.027-.313-.06-.467l4.7-2.74A1.997 1.997 0 0 0 14 3.333c0-1.106-.893-2-2-2s-2 .894-2 2c0 .16.027.314.06.467l-4.7 2.74A1.997 1.997 0 0 0 2 8a1.997 1.997 0 0 0 3.36 1.46l4.747 2.773a1.88 1.88 0 0 0-.054.434c0 1.073.874 1.946 1.947 1.946a1.949 1.949 0 0 0 1.947-1.946A1.949 1.949 0 0 0 12 10.72z",
		fillRule: "nonzero"
	})
});
export default SvgPath;
